import { useArgSelector } from '@/redux/curriedSelectors/curriedSelectors';
import getDateTimeAgo from '@/lib/getDateTimeAgo';
import Button from './Button';
import Tag from './Tag';
import appScreenSelectors from '@/screens/apps/redux/selectors/appScreenSelectors';
import appIssueActions from '@/screens/workflows/redux/actions/appIssueActions';
import { format } from 'date-fns';
import { useState } from 'react';
import ToggleIndicator from './ToggleIndicator';
import { useSelector } from 'react-redux';

const AppEditorIssueListRow = ({ issue }) => {
  const [isOpen, setIsOpen] = useState(false);
  const actionName = useArgSelector(appScreenSelectors.activeAppActionById, issue?.actionId)?.name;
  const appName = useSelector((state) => appScreenSelectors.activeApp(state)?.name);

  const toggleSection = () => {
    setIsOpen((prev) => !prev);
  };

  const handleIssue = () => {
    appIssueActions.set('handledOn', new Date(), {
      issueId: issue?.id
    });
    setIsOpen(false);
  };

  return (
    <div className={`issue-list-row ${issue?.handledOn ? 'handled' : ''}`}>
      <div className="issue-header" onClick={toggleSection}>
        <span className="issue-action-name">{actionName || `${appName} App`}</span>
        <div className="issue-tags">
          <Tag size="sm">
            <span>Version: {issue?.appVersion}</span>
          </Tag>
        </div>
        <ToggleIndicator isOpen={isOpen} />
      </div>
      {isOpen && (
        <div className="issue-content">
          <span className="issue-created-on" title={`Created ${getDateTimeAgo(issue?.createdOn)} by ${issue?.createdBy?.name}`}>
            <span className="time">{getDateTimeAgo(issue?.createdOn)} </span>
            <span>by </span>
            <span className="name">{issue?.createdBy?.name}</span>
          </span>
          <div className="issue-description">
            <p>{issue?.message}</p>
          </div>
          {!issue?.handledOn && (
            <Button size={'sm'} title="Mark this issue as Resolved" onClick={handleIssue}>
              Mark as Resolved
            </Button>
          )}
          {issue?.handledOn && (
            <span className="issue-handled-on" title={`Resolved on ${format(new Date(issue?.handledOn), 'MMM d, yyyy')}`}>
              <span className="time">Resolved on {format(new Date(issue?.handledOn), 'MMM d, yyyy')}</span>
            </span>
          )}
        </div>
      )}
    </div>
  );
};

export default AppEditorIssueListRow;
